import { Component, EventEmitter, Input, NgZone, OnInit, Output } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import * as moment from 'moment';
import { ManageType } from 'src/app/decorators/type-manager-decorator';
import { ItemAccessDialogComponent } from 'src/app/dialogs/item/item-access-dialog/item-access-dialog.component';
import { RecordContainer } from 'src/app/interfaces/record-container';
import { CNHealthProblem } from 'src/app/models/cnhealthproblem';
import { ProblemService } from 'src/app/services/problem.service';
import { RecordContainerMode } from '../../record/record-container/record-container.component';

declare var Ext: any;

@ManageType('ProblemRowComponent')
@Component({
  selector: 'app-problem-row',
  templateUrl: './problem-row.component.html',
  styleUrls: ['./problem-row.component.scss']
})
export class ProblemRowComponent implements OnInit, RecordContainer {

  @Input() record: CNHealthProblem;
  @Input() mode: RecordContainerMode = RecordContainerMode.compact;

  @Output() updated = new EventEmitter<CNHealthProblem>();

  constructor(private dialog: MatDialog, private ngZone: NgZone, public problemservice: ProblemService) { }

  ngOnInit(): void {
  }

  get date() {
    return moment(this.record.date).format('DD/MM/YYYY');
  }

  get startDate() {
    return (this.record.startDate) ? moment(this.record.startDate).format('DD/MM/YYYY') : '';
  }

  get endDate() {
    return (this.record.endDate) ? moment(this.record.endDate).format('DD/MM/YYYY') : '';
  }

  get active(): boolean {
    return (this.record.endDate) ? moment().isAfter(moment(this.record.endDate)) : false;
  }

  get user() {
    return '';
  }

  get content() {
    return this.record.value;
  }

  get description() {
    return this.record.getProperty('ProblemeDescription');
  }

  get significant() {
    return this.record.getProperty('Significant');
  }

  get risk(): boolean {
    return (this.record.getProperty('Risk') === 'Yes') ? true : false;
  }

  get family(): boolean {
    return (this.record.getProperty('FamilyHistory') === 'Yes') ? true : false;
  }

  get cisp(): string {
    return this.record.getProperty('CISPCode');
  }

  editProblem() {
    this.ngZone.runOutsideAngular(() => {
      setTimeout(() => {
        const problem = new Ext.CNHealthProblem(this.record.id);
        problem.on('itemLoaded', (item) => {
          const problemwindow = new Ext.CNProblemWindow({problem: item});
          problemwindow.show();
          problemwindow.on('problemUpdated', () => {
            this.ngZone.run(() => {
              this.updated.emit(this.record);
              this.problemservice.reloadAllSubjects();
            });
          });
        });
      });
    });
  }

  toggleRisk() {

  }

  openAccess() {
    const dialogRef = this.dialog.open(ItemAccessDialogComponent, {
      data: {
        item: this.record
      },
      maxWidth: '60%',
      minWidth: '480px'
    });
    dialogRef.afterClosed().subscribe(result => {
    });
  }
}
